import { storage as localStorage } from './storage';
import { Notification } from '../types';
import { systemLogService } from './systemLogService';

const KEYS = {
    NOTIFICATIONS: 'sbaj_notifications'
};

export const notificationService = {
    getNotifications: (userId: string): Notification[] => {
        const allNotifications = localStorage.get<Notification[]>(KEYS.NOTIFICATIONS, []);
        return allNotifications
            .filter(n => n.userId === userId || n.userId === 'all')
            .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    },

    createNotification: (notification: Omit<Notification, 'id' | 'createdAt' | 'read'>): Notification => {
        const notifications = localStorage.get<Notification[]>(KEYS.NOTIFICATIONS, []);
        const newNotification: Notification = {
            ...notification,
            id: Date.now().toString(),
            createdAt: new Date().toISOString(),
            read: false
        };
        localStorage.set(KEYS.NOTIFICATIONS, [newNotification, ...notifications]);
        return newNotification;
    },

    markAsRead: (notificationId: string): void => {
        const notifications = localStorage.get<Notification[]>(KEYS.NOTIFICATIONS, []);
        const updatedNotifications = notifications.map(n =>
            n.id === notificationId ? { ...n, read: true } : n
        );
        localStorage.set(KEYS.NOTIFICATIONS, updatedNotifications);
    },

    markAllAsRead: (userId: string): void => {
        const notifications = localStorage.get<Notification[]>(KEYS.NOTIFICATIONS, []);
        const updatedNotifications = notifications.map(n =>
            (n.userId === userId || n.userId === 'all') ? { ...n, read: true } : n
        );
        localStorage.set(KEYS.NOTIFICATIONS, updatedNotifications);
    },

    // Helper for broadcast
    broadcastNotification: (title: string, message: string, type: 'info' | 'success' | 'warning' | 'error' = 'info', link?: string) => {
        systemLogService.addLog('info', `Broadcast Alert Sent: ${title}`, message);
        return notificationService.createNotification({
            userId: 'all',
            title,
            message,
            type,
            link
        });
    }
};
